export { SymbolPickerService } from './lib/symbol-picker.service';
export { EmojiRecentlyUsedService } from './lib/emoji-recently-used.service';
export {
  SymbolPickerComponent,
  PICKER_ROW_SIZE,
} from './lib/symbol-picker/symbol-picker.component';
export { EmojiComponent } from './lib/emoji/emoji.component';
export { IconFontComponent } from './lib/icon-font/icon-font.component';
export { EmojiFallbackHtmlPipe } from './lib/emoji-fallback-html/emoji-fallback-html.pipe';

export { EmojiSupport, EmojiSupportService } from './lib/emoji-support.service';

export { NameSymbolInputComponent } from './lib/name-symbol-input/name-symbol-input.component';
export * from './lib/symbol.types';
export { SymbolComponent } from './lib/symbol/symbol.component';
